<template>
  <section class="dashboard-page dashboard-full-bleed">
    <div class="report-shell report-shell-full">
      <div v-if="carga" class="report-loading" role="status" aria-live="polite">
        <div class="brand-watermark"></div>
        <SpinnerQhatu class="spinner-qhatu" />
        <div class="loading-copy">
          <strong>Preparando tu reporte</strong>
          <span>Esto puede tomar unos segundos.</span>
        </div>
      </div>

      <div v-if="errorPowerBI" class="report-error" role="alert">
        <i class="bi bi-exclamation-triangle"></i>
        <strong>No se pudo mostrar el reporte</strong>
        <span>{{ errorPowerBI }}</span>
        <button type="button" class="btn-refresh" @click="recargar">Reintentar</button>
      </div>
      <div id="powerBIcontainer" class="report-container" :class="{ 'report-hidden': carga || errorPowerBI }"></div>
    </div>
  </section>
</template>

<script>
import SpinnerQhatu from "@/components/SpinnerQHATU/Spinne.vue";
import { mapGetters, mapActions } from "vuex";
import * as pbi from "powerbi-client";

export default {
  name: "BYCliente",
  components: { SpinnerQhatu },
  data() {
    return {
      parametroBI: [],
      carga: true,
      errorPowerBI: "",
      embedConfig: {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: "",
        embedUrl: "",
        id: "",
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      },
      report: null,
      powerbiService: null
    };
  },
  computed: {
    ...mapGetters("users", ["Items", "ModuloRapido", "IconoModulo", "Idreporte", "Idgrupo"]),
    activarTokenbi() {
      return this.$store.getters["users/ActivarTokenbi"];
    }
  },
  watch: {
    $route() {
      // Conserva el comportamiento original: la ruta solo actualiza el vínculo.
      this.cargarLinkPowerBI();
    },
    activarTokenbi(newValue) {
      // La selección del menú es la única que dispara el embed.
      if (newValue) {
        this.tokenbi();
        this.$store.commit("users/activarTokenbi", false);
      }
    }
  },
  created() {
    this.getAttributes();
  },
  mounted() {
    window.addEventListener("qhatu-refresh-view", this.recargar);
    window.addEventListener("resize", this.handleViewportResize);
    this.powerbiService = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    this.cargarLinkPowerBI();
  },
  beforeDestroy() {
    window.removeEventListener("qhatu-refresh-view", this.recargar);
    window.removeEventListener("resize", this.handleViewportResize);
    const container = document.getElementById("powerBIcontainer");
    if (container && this.powerbiService) this.powerbiService.reset(container);
  },
  methods: {
    ...mapActions("users", ["getAttributes"]),
    handleViewportResize() {
      if (!this.report || this.carga) return;
      window.clearTimeout(this._qhatuResizeTimer);
      this._qhatuResizeTimer = window.setTimeout(() => {
        this.applyResponsivePageView();
      }, 120);
    },
    applyResponsivePageView() {
      if (!this.report || typeof this.report.setPageView !== "function") return;
      const pageView = window.innerWidth <= 991.98 ? "fitToWidth" : "fitToPage";
      this.report.setPageView(pageView).catch(() => {});
    },
    recargar() {
      if (this.Idgrupo && this.Idreporte) this.tokenbi();
      else this.cargarLinkPowerBI();
    },
    cargarLinkPowerBI() {
      this.parametroBI = [];
      this.errorPowerBI = "";
      this.carga = true;
      this.axios
        .get(`BIClientes/EncontrarLinkBi?idCategoria=${this.$route.params.idCategoria}`)
        .then(response => {
          this.parametroBI = response.data || [];
          // Igual que la versión original: esta consulta no reemplaza tokenbi().
          // La carga real se activa desde el menú mediante activarTokenbi.
        })
        .catch(error => {
          console.error("Error al encontrar el enlace Power BI:", error);
          this.errorPowerBI = "No se pudo obtener la configuración del dashboard.";
          this.carga = false;
        });
    },
    tokenbi() {
      const workspaceId = `${this.Idgrupo || ""}`;
      const reportId = `${this.Idreporte || ""}`;

      if (!workspaceId || !reportId) {
        this.errorPowerBI = "No se encontraron los identificadores del dashboard seleccionado.";
        this.carga = false;
        return;
      }

      this.errorPowerBI = "";
      this.carga = true;

      // Se restaura el mismo cliente Axios y la misma llamada que funcionaban originalmente.
      this.axios
        .get("https://pythonbi.gruposolimano.com.pe/getembedinfo", {
          params: {
            WORKSPACE_ID: workspaceId,
            REPORT_ID: reportId
          }
        })
        .then(response => {
          if (response.status === 200 && response.data && response.data.reportConfig) {
            const reportConfig = response.data.reportConfig[0];
            if (!reportConfig || !reportConfig.embedUrl || !reportConfig.reportId || !response.data.accessToken) {
              throw new Error("La respuesta de Power BI no contiene todos los datos requeridos.");
            }

            this.embedConfig = {
              ...this.embedConfig,
              accessToken: response.data.accessToken,
              embedUrl: reportConfig.embedUrl,
              id: reportConfig.reportId
            };

            this.$nextTick(() => this.embedReport());
          } else {
            throw new Error("Estructura de respuesta inesperada de Power BI.");
          }
        })
        .catch(error => {
          console.error("Error fetching embed info:", error);
          this.errorPowerBI = "No fue posible cargar el dashboard de Power BI.";
          this.carga = false;
        });
    },
    embedReport() {
      const container = document.getElementById("powerBIcontainer");
      if (!container || !this.powerbiService) {
        this.errorPowerBI = "No se encontró el contenedor del dashboard.";
        this.carga = false;
        return;
      }

      this.powerbiService.reset(container);
      this.report = this.powerbiService.embed(container, this.embedConfig);

      this.report.off("loaded");
      this.report.off("rendered");
      this.report.off("error");

      // La versión original mostraba el contenedor inmediatamente después del embed.
      this.carga = false;

      this.report.on("loaded", () => {
        this.errorPowerBI = "";
        this.applyResponsivePageView();
      });
      this.report.on("rendered", () => {
        this.errorPowerBI = "";
        this.applyResponsivePageView();
      });
      this.report.on("error", event => {
        console.error("Power BI embed error:", event && event.detail ? event.detail : event);
        this.errorPowerBI = "Power BI devolvió un error al mostrar el dashboard.";
        this.carga = false;
      });
    }
  }
};
</script>

<style scoped>
.dashboard-page {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.dashboard-full-bleed {
  width: 100%;
  margin: 0;
  min-height: 100vh;
}

.report-shell {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  background: #fff;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.report-shell-full {
  width: 100%;
  height: 100vh;
}

.report-container {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  visibility: visible;
}

.report-container.report-hidden {
  visibility: hidden;
}

.report-error,
.report-loading {
  position: absolute;
  inset: 0;
}

.report-error {
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .6rem;
  text-align: center;
  padding: 2rem;
  background: #fff;
  color: var(--qhatu-muted);
}

.report-error i {
  font-size: 2rem;
  color: #d97706;
}

.report-error strong {
  color: var(--qhatu-text);
}

.report-loading {
  z-index: 2;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: linear-gradient(145deg, #fff, #f5f9fe);
  text-align: center;
}

.brand-watermark {
  position: absolute;
  inset: 0;
  opacity: .035;
  background: url('../../assets/Principal/logoEspera.png') center/420px no-repeat;
}

.spinner-qhatu,
.loading-copy {
  position: relative;
  z-index: 1;
}

.loading-copy {
  display: flex;
  flex-direction: column;
  gap: .25rem;
  color: var(--qhatu-muted);
}

.loading-copy strong {
  color: var(--qhatu-text);
  font-size: 1rem;
}

.btn-refresh {
  min-height: 44px;
  border: 1px solid var(--qhatu-border);
  background: #fff;
  color: var(--qhatu-primary-dark);
  border-radius: 12px;
  padding: .65rem 1rem;
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  font-weight: 700;
}

.btn-refresh:hover {
  background: var(--qhatu-primary-soft);
}

@media (max-width: 991.98px) {
  .dashboard-full-bleed,
  .report-shell,
  .report-shell-full,
  .report-container {
    width: 100%;
    min-height: 100dvh;
    height: 100dvh;
  }

  .report-loading {
    min-height: 100%;
  }
}
</style>
